const shallow=[
  ['入口の桶','Entrance Oke','鯵の群れ','無數小鯵撞擊桶壁，學會追逐旬味。','Countless aji strike the oke walls, teaching the pursuit of freshness.','swarm'],
  ['朝市の風','Morning Market Wind','小肌','清晨叫賣聲沿著疾風穿過桶面。','Morning market calls ride a swift wind across the water.','wind'],
  ['桜流し','Flowing Sakura','櫻鯛','櫻瓣落水，櫻鯛追著春光洄游。','Petals touch the water as sakura-dai chase the spring light.','sakura'],
  ['刀の試し','Blade Trial','飛魚','刀必須追上躍出急流的飛魚。','The blade must catch flying fish escaping the racing current.','blades'],
  ['塩の記憶','Memory of Salt','鹽漬鯖魚','鹽晶覆滿桶壁，保存海風記憶。','Salt crystals cover the oke, preserving a memory of sea wind.','salt'],
  ['鰯の銀河','Sardine Galaxy','沙丁魚','萬尾銀魚旋成只屬於清晨的銀河。','Ten thousand sardines turn into a galaxy of morning silver.','galaxy'],
  ['鮭の目覚め','Salmon Awakening','幼鮭','紅澪血脈甦醒，祖鮭心跳響起。','Akashio blood awakens to the heartbeat of the ancestral salmon.','heartbeat'],
  ['水面の月','Moon on Water','月影鯛','滿月沉在水面，魚群不敢打破倒影。','A full moon rests on water that no fish dares disturb.','moon'],
  ['貝の囁き','Whisper of Shell','赤貝','蛤蜊以潮聲低唱，赤貝藏在歌裡。','Clams sing with the tide while akagai hide inside their song.','shells'],
  ['迴游の迷路','Labyrinth of Migration','鰹','每一道水流都把獵物帶向另一條路。','Every current carries the migrating catch toward another path.','maze'],
  ['子供の包丁',"Child's Knife",'小鯵','學徒斷刀沉底，仍映著未完的夢。','Broken apprentice knives reflect dreams left unfinished.','broken-blades'],
  ['鰤の影','Shadow of Yellowtail','鰤','巨大的鰤影掠過，永遠快一步。','A giant yellowtail shadow passes, always one beat ahead.','shadow'],
  ['泡沫の駅','Station of Bubbles','白魚','氣泡列車載著白魚駛向水面。','Bubble trains carry icefish toward the surface.','bubbles'],
  ['醤油の雨','Soy Sauce Rain','鰹','醬油如雨落下，清水逐漸染成琥珀。','Soy rain slowly stains the clear water amber.','soy-rain'],
  ['酢飯の霧','Vinegared Rice Fog','小肌','溫熱醋飯霧氣遮住魚群的去向。','Warm vinegared-rice mist hides the path of the fish.','rice-fog'],
  ['猫の板前','Cat Itamae','鯖魚','貓板前悄悄偷走最肥美的一尾。','A cat itamae quietly steals the finest fish.','cat'],
  ['潮騒の教室','Classroom of Tide','細魚','潮汐黑板教導何時出刀，何時等待。','A tidal blackboard teaches when to cut and when to wait.','classroom'],
  ['剥がれた漆','Peeled Lacquer','真鯛','剝落黑漆下，百年木紋仍在呼吸。','Beneath peeling lacquer, century-old wood grain still breathes.','lacquer'],
  ['飛沫の剣','Sword of Splash','太刀魚','躍起的魚與水花化為無數銀劍。','Leaping fish and spray become a storm of silver swords.','splash-swords'],
  ['鰤の試練','Trial of Buri','巨大鰤王','鰤王撕裂急流，只有移動中的一刀能勝。','The Buri King tears through the current; only a moving cut can prevail.','buri-boss'],
  ['午後の怠惰','Afternoon Sloth','熟成鯵','午後水流停滯，魚群在暖光中沉睡。','The afternoon current slows and fish sleep in warm light.','sleep'],
  ['硝子の鱗','Glass Scale','銀鱗魚','玻璃鱗片漂浮，閃耀而鋒利。','Glass scales drift through the water, beautiful and sharp.','glass'],
  ['問診票の漂着','Drifting Questionnaire','客人的問診票','未說出口的心事漂到桶的中央。','An unspoken wish drifts toward the center of the oke.','paper'],
  ['箸の墓場','Graveyard of Chopsticks','穴子','斷筷堆成山，記錄每次失手。','Broken chopsticks form a mountain of remembered mistakes.','chopsticks'],
  ['銀の渦','Silver Vortex','銀色鯵王','萬尾鯵化為龍捲，守護洄游層出口。','Ten thousand aji become a vortex guarding the realm exit.','vortex-boss'],
  ['涙の味','Taste of Tears','鹽漬小肌','學徒的眼淚讓整桶水嚐起來像海。','Apprentice tears make the whole oke taste like the sea.','tears'],
  ['夕凪','Evening Calm','夕鯛','夕陽將清澈水面染成金紅。','The setting sun turns the clear water crimson and gold.','sunset'],
  ['陽の名残','Last Remnant of Sun','金目鯛','最後一束陽光追著金色魚眼下沉。','The final ray follows a golden eye into the deep.','last-light'],
  ['境界の膜','Membrane of Border','無光魚','穿過水面的薄膜，晨光便永遠留在身後。','Pass through the membrane and morning light remains behind forever.','membrane']
];

const deep=[
  ['重力の始まり','Beginning of Gravity','深海鯛','每一次呼吸都比上一刻更沉重。','Every breath becomes heavier than the last.','gravity'],
  ['深海の雪','Deep Sea Snow','深海白魚','海雪緩慢落下，埋沒匆忙的念頭。','Marine snow falls slowly, burying all haste.','snow'],
  ['鮪の寝床','Tuna Bed','沉睡鮪魚','巨大鮪魚在桶底打呼，水面隨之震動。','A giant sleeping tuna makes the water tremble with every snore.','sleeping-tuna'],
  ['鮟鱇の提灯',"Angler's Lantern",'鮟鱇魚','唯一的燈在黑暗中引誘迷路者。','A single angler light lures the lost through darkness.','lantern'],
  ['鮪の重圧','Pressure of Tuna','赤身','水壓讓木桶彎曲，也考驗持刀之心。','Pressure bends the wooden oke and tests the hand holding the knife.','pressure'],
  ['海胆の棘の森','Forest of Uni Spines','海膽','無數海膽刺構成不可觸碰的森林。','Countless uni spines form a forest that cannot be touched.','spines'],
  ['烏賊の墨の夜','Ink Night of Squid','烏賊','一口神墨吐出，整層失去邊界。','One burst of squid ink erases every boundary.','ink'],
  ['深海の醤油樽','Deep Soy Barrel','沉熟醬油','沉沒醬油樽緩慢滲出百年鹹香。','A sunken soy barrel releases a century of flavor.','barrel'],
  ['錆びた包丁','Rusty Knife','深海白身','鏽刀要求比鋒利刀刃更純熟的手。','Rusty knives demand hands more precise than sharp steel.','rust'],
  ['鯨の骨','Whale Bone','鯨骨高湯','巨大的鯨骨橫跨黑水成為唯一橋樑。','A colossal whale skeleton bridges the black water.','whale-bones'],
  ['鰻の火路',"Eel's Path of Fire",'鰻魚','水中火路只為懂得守火的人燃燒。','A path of underwater fire burns only for those who tend it.','fire-path'],
  ['蟹の牢獄','Crab Prison','松葉蟹','鐵籠裡的蟹群等待耐心解開鎖扣。','Crabs wait in iron cages for patient hands to free them.','cages'],
  ['逆さの市場','Upside-down Market','深海旬魚','市場倒掛水面，價格與重力一同失序。','A market hangs upside down where prices and gravity lose order.','upside-market'],
  ['水圧の箸','Pressured Chopsticks','蛸','筷子被水壓彎曲，夾取需要新的力度。','Pressure bends the chopsticks and demands a gentler strength.','bent-chopsticks'],
  ['玉澄の涙',"Tamachiyo's Tear",'溫水玉子','玉澄的手癖讓重壓海水變得溫暖。','Tamachiyo resonance turns crushing water warm and protective.','warm-tear'],
  ['海月の揺り籠','Jellyfish Cradle','海月','磷光水母像搖籃般托住下沉的人。','Bioluminescent jellyfish cradle those sinking through the dark.','jellyfish'],
  ['深海の祭壇','Deep Altar','魚骨出汁','魚骨祭壇等待一份不求回報的獻禮。','A fish-bone altar awaits an offering made without reward.','altar'],
  ['凍った醤油','Frozen Soy','冰封赤身','醬油結成黑冰，味道封存在裂縫裡。','Soy freezes into black ice, trapping flavor in its cracks.','frozen-soy'],
  ['沈黙の群れ','Silent School','靜止魚群','魚群完全靜止，只有眼睛跟隨訪客。','The school remains perfectly still while every eye follows the visitor.','silent-school'],
  ['中間の目','Eye of Middle','塔心之眼','向上仍有微光，向下只剩無底黑暗。','Light survives above, while below there is no visible end.','middle-eye'],
  ['血の潮','Tide of Blood','鮪血','鮪紅潮水湧起，將所有磷光染暗。','A tuna-blood tide rises and dims every living light.','blood-tide'],
  ['鮪の心臓','Heart of Tuna','鮪魚心','沉重心跳推動整層水流。','A heavy tuna heartbeat drives every current on the floor.','tuna-heart'],
  ['深海の包丁研ぎ','Deep Knife Sharpening','砥石','刀刃必須在巨大水壓下重新甦醒。','A blade must be awakened beneath crushing pressure.','sharpening'],
  ['失われたレシピ','Lost Recipe','古代旬味','破爛食譜漂浮，每一頁缺少一個步驟。','A ruined recipe drifts with one step missing from every page.','recipe'],
  ['王鮪の王座','Throne of King Tuna','五十米巨大本鮪','紅寶石眼的王鮪盤踞深海王座。','A fifty-meter bluefin with ruby eyes circles its abyssal throne.','tuna-boss'],
  ['王の抜け殻',"King's Shell",'王鮪魚皮','王者蛻皮像一面巨大旗幟飄動。','The king’s shed skin drifts like a colossal banner.','king-shell'],
  ['深海の花束','Bouquet of Deep Sea','深海魚束','磷光魚群組成一束獻給黑暗的花。','Bioluminescent fish form a bouquet offered to darkness.','bouquet'],
  ['圧壊の跡','Trace of Crush','碎桶熟成魚','被壓碎的木桶留下失敗者的輪廓。','Crushed oke remains preserve the outlines of those who failed.','wreckage'],
  ['無光の底','Bottomless Lightless','盲目深海魚','絕對黑暗中，雙手成為唯一的眼睛。','In absolute darkness, the hands become the only eyes.','blackout']
];

const ancient=[
  ['古い俎板の匂い','Smell of Old Cutting Board','霉香白身','潮濕木香喚醒被埋藏的刀痕。','Damp wood awakens cuts buried by time.','old-board'],
  ['昆布の森','Forest of Kombu','百年昆布','巨大昆布林封住通往古法的道路。','Giant kombu blocks the road toward ancient technique.','kombu'],
  ['失われた〆','Lost Shime Technique','古法小肌','失傳酢締藏在殘缺的味覺記憶裡。','A lost curing method survives in fractured taste memory.','lost-shime'],
  ['骨の包丁','Bone Knife','古代鯛','魚骨刀刃要求持刀者理解生命重量。','A fish-bone knife asks its wielder to understand the weight of life.','bone-knives'],
  ['塩の化石','Fossil of Salt','化石海鹽','遠古海水凝成保存時間的鹽石。','Primeval seawater became salt stone that preserves time.','salt-fossil'],
  ['枯れた山葵','Withered Wasabi','枯山葵','枯死山葵田仍在等待一滴清水。','A dead wasabi field still waits for one drop of clear water.','withered-field'],
  ['割れた桶','Cracked Oke','漏水穴子','裂縫不停漏水，記憶也隨之流失。','Water and memory escape endlessly through the cracked oke.','cracks'],
  ['板長の影','Shadow of Head Chef','初代刀影','初代料理長的影子重複同一記切法。','The first head chef’s shadow repeats a single eternal cut.','chef-shadow'],
  ['逆さの包丁','Inverted Knife','鏡中白身','所有刀尖朝向自己，先切開傲慢。','Every knife points inward, cutting pride before fish.','inverted-knives'],
  ['酢の淵','Abyss of Vinegar','赤酢漬鮪','整層濃醋使眼淚與味覺一同甦醒。','An abyss of vinegar awakens tears and taste together.','vinegar'],
  ['埋もれた献立','Buried Menu','百年前旬味','沙底菜單記著已不存在的季節。','Menus beneath the sand remember seasons that no longer exist.','buried-menu'],
  ['鯖の古文書','Ancient Mackerel Scroll','文字鯖','鯖魚花紋化成只有刀能讀懂的文字。','Mackerel markings become script readable only by a blade.','scroll-fish'],
  ['包丁塚','Mound of Knives','古代白身','千把舊刀插入地面，如無名板前墓碑。','A thousand knives stand as graves for nameless itamae.','knife-mound'],
  ['腐った木の味','Taste of Rotten Wood','木桶熟成魚','腐木氣味掩蓋一縷仍未消失的鮮。','Rotten wood conceals one trace of freshness that refuses to die.','rot'],
  ['鰯の怨','Grudge of Sardine','沙丁魚怨靈','被浪費的魚化成銀色怨靈索問理由。','Wasted sardines return as silver spirits demanding an answer.','ghost-school'],
  ['過去の客','Guest From Past','百年幻席','百年前的客人仍在享用未完的一席。','Guests from a century ago continue an unfinished meal.','ghost-guests'],
  ['凍った時間','Frozen Time','凝止旬魚','魚與刀停在切割前的最後一瞬。','Fish and blade freeze in the final instant before the cut.','frozen-time'],
  ['醤油の滝','Waterfall of Soy Sauce','古醬油','黑色瀑布沖刷所有過度自信的味道。','A black waterfall washes away every overconfident flavor.','soy-waterfall'],
  ['漆の剥離','Lacquer Peeling','漆封貝類','大片黑漆剝落，露出桶的赤紅內裡。','Sheets of black lacquer reveal the oke’s crimson heartwood.','peeling'],
  ['古法の心臓','Heart of Ancient Method','活古法','被遺忘的技法仍以沉緩節奏跳動。','Forgotten techniques continue beating with a slow rhythm.','ancient-heart'],
  ['鮨の幽霊','Ghost of Sushi','幽靈鮨','完成的壽司離開俎板，尋找原來的客人。','Finished sushi drifts away in search of its original guest.','ghost-sushi'],
  ['無名の魚','Nameless Fish','無名古魚','沒有任何語言能叫出這尾魚的名字。','No surviving language can speak the name of this fish.','nameless'],
  ['板前の墓','Grave of Itamae','板前記憶','俎板墓碑記錄一生只完成一次的刀法。','Cutting-board graves remember techniques performed only once.','itamae-graves'],
  ['逆さの鳥居','Inverted Torii','倒懸旬味','倒置鳥居要求人放棄熟悉的方向。','An inverted torii demands the surrender of familiar direction.','inverted-torii'],
  ['忘却の板長','Forgotten Head Chef','幻影初代料理長','百刀幻影追問：什麼才是真正的鮮度。','The hundred-bladed first chef asks what freshness truly means.','chef-boss'],
  ['板長の涙','Tear of Head Chef','初代之淚','初代第一滴眼淚凝成不會失去光的珍珠。','The first chef’s first tear becomes a pearl that never dims.','pearl'],
  ['最後の酢飯','Last Vinegared Rice','冷卻酢飯','最後一口飯已冷，仍等待最後一位客人。','The final rice has gone cold while waiting for its final guest.','cold-rice'],
  ['空の桶','Empty Oke','虛無','空桶沒有任何答案，只放大自己的心聲。','The empty oke offers no answer and amplifies only the self.','void'],
  ['最古の俎板','Oldest Cutting Board','始祖旬味','世界第一塊俎板留著神明親手落下的刀痕。','The first cutting board bears a knife mark made by a god.','god-scar']
];

const mythical=[
  ['鮭神の鱗','Scale of Salmon God','金色神鮭鱗','紅色極光中，神鱗如燃燒隕石漂浮。','Golden salmon scales drift like burning meteors beneath a red aurora.','salmon-god'],
  ['卵神の黄身','Yolk of Tamago God','神之半熟玉子','溫暖蛋黃世界隨每一步柔和晃動。','A warm soft-yolk world trembles gently beneath every step.','tamago-god'],
  ['甘海老神の跳ね','Leap of Sweet Shrimp God','櫻色蝦神','巨大蝦神躍起時，整個宇宙放慢呼吸。','Time slows whenever the giant pink shrimp god leaps.','shrimp-god'],
  ['烏賊神の墨','Ink of Squid God','宇宙神墨','一滴神墨落下，光明與星辰同時消失。','One drop of divine ink extinguishes light and stars together.','squid-god'],
  ['海胆神の爆ぜ','Burst of Sea Urchin God','金色海膽神','神海膽如超新星爆開，釋放純粹鮮味。','The golden uni god erupts like a supernova of pure flavor.','uni-god'],
  ['鯖神の群れ','School of Mackerel God','銀河神鯖','神鯖群以銀色身軀形成完整銀河。','Divine mackerel form an entire galaxy with silver bodies.','mackerel-god'],
  ['鮪神の眼','Eye of Tuna God','神鮪之眼','巨大神眼衡量刀、心與每次選擇。','A colossal tuna eye judges the blade, heart, and every choice.','tuna-eye'],
  ['鯨神の歌','Song of Whale God','鯨神之歌','鯨神低唱，百層木桶同時產生共鳴。','The whale god sings and all one hundred oke resonate together.','whale-song'],
  ['旬神の集い','Gathering of Shun Gods','眾旬神幻影','所有旬神聚集，判斷來者是否值得抵達源頭。','Every seasonal god gathers to judge who may approach the source.','god-gathering'],
  ['源の淵','Gen no Fuchi · The Source','百年味噌心臟','月球般的心臟與客人問診票同步跳動，孕育一期一會。','A moon-sized miso heart beats with the guest and births one unrepeatable encounter.','source-heart']
];

const safeFloors={
  30: {
    floor: 30,
    name_zh: '問診之間',
    name_en: 'Diagnosis Chamber',
    realm: 'Shallow',
    ingredient: '客人的問診票',
    guardian: '無・安全層',
    scene: 'diagnosis-room',
    flavor_text_zh: '白沙無風，百年木桌上的問診票正發光。',
    flavor_text_en: 'In windless white sand, a questionnaire glows upon a century-old table.'
  },
  60: {
    floor: 60,
    name_zh: '焼火之間',
    name_en: 'Chamber of Baking Fire',
    realm: 'Deep',
    ingredient: '玉澄之守火',
    guardian: '無・安全層',
    scene: 'fire-room',
    flavor_text_zh: '黑鳥居守著水中爐火，地上鋪滿溫暖木炭。',
    flavor_text_en: 'A black torii guards Tamachiyo fire burning warmly beneath the water.'
  },
  90: {
    floor: 90,
    name_zh: '無心之間',
    name_en: 'Chamber of No-Mind',
    realm: 'Ancient',
    ingredient: '透明高湯',
    guardian: '無・最終安全層',
    scene: 'no-mind-room',
    flavor_text_zh: '透明高湯無味卻包容萬味，四周絕對無音。',
    flavor_text_en: 'Clear dashi tastes of nothing and everything within absolute silence.'
  }
};

const realmSettings={
  Shallow: {
    color: '#87CEEB',
    water: '#55bce8',
    guardian: '追上洄游魚群，在水流轉向前取得旬味',
    visual: 'clear morning water, pale mist, sunlight caustics'
  },
  Deep: {
    color: '#0A1931',
    water: '#08204d',
    guardian: '承受深海重壓，以耐心與火候取得旬味',
    visual: 'viscous deep water, pressure fog, bioluminescence'
  },
  Ancient: {
    color: '#4A0E0E',
    water: '#3b0909',
    guardian: '從殘缺記憶重現失落的古代板前技法',
    visual: 'dark dashi water, drifting sediment, ruined lacquer'
  },
  Mythical: {
    color: '#FFD700',
    water: '#fff5b0',
    guardian: '通過血脈共鳴與旬神的資格審判',
    visual: 'weightless light, white-gold memory, sacred bloom'
  }
};

function hashScene(scene,floor) {
  return [...scene].reduce((total,char)=> (total * 31 + char.charCodeAt(0)) % 997, floor);
}

function createFloor(entry,index,realm,start) {
  const floor=start + index;
  const [name_zh,name_en,ingredient,flavor_text_zh,flavor_text_en,scene]=entry;
  const settings=realmSettings[realm];
  const seed=hashScene(scene,floor);

  return {
    floor,
    name_zh,
    name_en,
    realm,
    ingredient,
    guardian: settings.guardian,
    visual: `${settings.visual}, ${scene}`,
    scene,
    color: settings.color,
    water: settings.water,
    water_quality: realm==='Shallow'
      ? '清澈晨霧'
      : realm==='Deep'
        ? '黏稠重壓磷光'
        : realm==='Ancient'
          ? '濃厚高湯與沉渣'
          : '光與記憶・無重力',
    geometry: {
      radius: Number((2.05 + (seed % 11) * .035).toFixed(3)),
      wallHeight: Number((.38 + (seed % 7) * .055).toFixed(3)),
      slats: 18 + seed % 19,
      rimWidth: Number((.11 + (seed % 5) * .018).toFixed(3)),
      warp: Number(((seed % 9) * .018).toFixed(3))
    },
    behavior: {
      count: 12 + seed % 34,
      speed: Number((.22 + (seed % 13) * .055).toFixed(3)),
      orbit: Number((.65 + (seed % 8) * .13).toFixed(3)),
      turbulence: Number((.1 + (seed % 10) * .07).toFixed(3)),
      direction: seed % 2 ? 1 : -1
    },
    flavor_text_zh,
    flavor_text_en
  };
}

function safeFloor(data) {
  const settings=realmSettings[data.realm];
  return {
    ...data,
    visual: `${settings.visual}, rest chamber, chairs, enterable torii`,
    color: settings.color,
    water: settings.water,
    water_quality: data.floor===90 ? '透明高湯・絕對無音' : '平靜安全水域',
    geometry: {
      radius: 2.7,
      wallHeight: .28,
      slats: 30,
      rimWidth: .18,
      warp: 0
    },
    behavior: {
      count: 8,
      speed: .12,
      orbit: 1.2,
      turbulence: .05,
      direction: 1
    }
  };
}

export const fuchiFloors=[
  ...shallow.map((entry,index)=> createFloor(entry,index,'Shallow',1)),
  safeFloor(safeFloors[30]),
  ...deep.map((entry,index)=> createFloor(entry,index,'Deep',31)),
  safeFloor(safeFloors[60]),
  ...ancient.map((entry,index)=> createFloor(entry,index,'Ancient',61)),
  safeFloor(safeFloors[90]),
  ...mythical.map((entry,index)=> createFloor(entry,index,'Mythical',91))
];

export const getFuchiFloor=(floor)=> fuchiFloors[floor - 1];